export default __webpack_public_path__ + "static/laffayette_comic_pro-webfont-37f2c2fbe8b102ed24e9fd44ca7e8073.svg";